import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Chatbot from './components/ChatbotNew';

// Fonction pour vérifier l'authentification
const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

    useEffect(() => {
        // Vérifier si l'utilisateur est authentifié (par exemple en vérifiant le localStorage)
        const userId = localStorage.getItem('userId');
        document.title = "Amministrazione page";
         // Modifier dynamiquement l'icône de la page en fonction de l'état d'authentification
         const link: HTMLLinkElement | null = document.querySelector("link[rel='icon']");
         if (link) {
             if (userId) {
                 setIsAuthenticated(true);
                 link.href = "https://islandsofchange.org/wp-content/uploads/2019/03/SCRITTA-1.png"; // Remplacez ceci par votre icône lorsque l'utilisateur est authentifié
             } else {
                 setIsAuthenticated(false);
                 link.href = "path/to/default-icon.ico"; // Remplacez ceci par votre icône par défaut
             }
         }
        if (userId) {
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
    }, []);

    return { isAuthenticated };
};

const App: React.FC = () => {
    const { isAuthenticated } = useAuth();

    return (
        <Router>
            
            <div className="min-h-screen bg-gray-50">
                <Routes>
                    {/* Si l'utilisateur est authentifié, il est redirigé vers le dashboard */}
                    <Route
                        path="/"
                        element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
                    />
                    {/* Route de connexion */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/chatbot" element={<Chatbot />} />
                   
                </Routes>
            </div>
        </Router>
    );
};

export default App;
